export default __webpack_public_path__ + "static/media/crayon.47ff472c.ogg";